"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = { class: "form-container" };
const _hoisted_3 = { class: "form-navigation" };
const _hoisted_4 = ["onSubmit"];
const _hoisted_5 = { class: "button-row" };
const LocationFormData_vue_1 = __importDefault(require("./LocationFormData.vue"));
const LocationFormProperties_vue_1 = __importDefault(require("./LocationFormProperties.vue"));
const LocationFormServices_vue_1 = __importDefault(require("./LocationFormServices.vue"));
const LocationFormOpeningHours_vue_1 = __importDefault(require("./LocationFormOpeningHours.vue"));
const LocationFormServiceStations_vue_1 = __importDefault(require("./LocationFormServiceStations.vue"));
const FormNavigationButton_vue_1 = __importDefault(require("../../../../components/backend/FormNavigationButton.vue"));
const CustomButton_vue_1 = __importDefault(require("../../../../components/backend/CustomButton.vue"));
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'LocationForm',
    setup(__props) {
        const currentStep = (0, vue_3.ref)(1);
        const submitForm = () => {
            // Űrlap adatainak kezelése és elküldése
            console.log("currentStep: " + currentStep.value);
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(FormNavigationButton_vue_1.default, {
                            "is-active": currentStep.value === 1,
                            text: "Adatok",
                            onClick: _cache[0] || (_cache[0] = ($event) => (currentStep.value = 1))
                        }, null, 8, ["is-active"]),
                        (0, vue_2.createVNode)(FormNavigationButton_vue_1.default, {
                            "is-active": currentStep.value === 2,
                            text: "Tulajdonságok",
                            onClick: _cache[1] || (_cache[1] = ($event) => (currentStep.value = 2))
                        }, null, 8, ["is-active"]),
                        (0, vue_2.createVNode)(FormNavigationButton_vue_1.default, {
                            "is-active": currentStep.value === 3,
                            text: "Szolgáltatások",
                            onClick: _cache[2] || (_cache[2] = ($event) => (currentStep.value = 3))
                        }, null, 8, ["is-active"]),
                        (0, vue_2.createVNode)(FormNavigationButton_vue_1.default, {
                            "is-active": currentStep.value === 4,
                            text: "Nyitvatartás",
                            onClick: _cache[3] || (_cache[3] = ($event) => (currentStep.value = 4))
                        }, null, 8, ["is-active"]),
                        (0, vue_2.createVNode)(FormNavigationButton_vue_1.default, {
                            "is-active": currentStep.value === 5,
                            text: "Állások",
                            onClick: _cache[4] || (_cache[4] = ($event) => (currentStep.value = 5))
                        }, null, 8, ["is-active"])
                    ]),
                    (0, vue_2.createElementVNode)("form", {
                        id: "location-form",
                        class: "full-form",
                        onSubmit: (0, vue_2.withModifiers)(submitForm, ["prevent"])
                    }, [
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(LocationFormData_vue_1.default, null, null, 512), [
                            [vue_2.vShow, currentStep.value === 1]
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(LocationFormProperties_vue_1.default, null, null, 512), [
                            [vue_2.vShow, currentStep.value === 2]
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(LocationFormServices_vue_1.default, null, null, 512), [
                            [vue_2.vShow, currentStep.value === 3]
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(LocationFormOpeningHours_vue_1.default, null, null, 512), [
                            [vue_2.vShow, currentStep.value === 4]
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(LocationFormServiceStations_vue_1.default, null, null, 512), [
                            [vue_2.vShow, currentStep.value === 5]
                        ])
                    ], 40, _hoisted_4),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                            "btn-type": "success",
                            onClick: submitForm
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)("Mentés")
                            ]),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(CustomButton_vue_1.default, { "btn-type": "danger" }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)("Törlés")
                            ]),
                            _: 1
                        })
                    ])
                ])
            ]));
        };
    }
});
